import { CEILING_HEIGHT } from '../draftKeys';
import { selectDraftDataSlice } from '../draftSelectors';

export const selectDraftCeilingHeight = selectDraftDataSlice(CEILING_HEIGHT);
